import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.careerPriority.financialSecurity',
    subtitle: 'pages.onboarding.careerPriority.financialSecuritySub',
    value: 'financial-security',
  },
  {
    title: 'pages.onboarding.careerPriority.careerGrowth',
    subtitle: 'pages.onboarding.careerPriority.careerGrowthSub',
    value: 'career-growth',
  },
  {
    title: 'pages.onboarding.careerPriority.stayingRelevant',
    subtitle: 'pages.onboarding.careerPriority.stayingRelevantSub',
    value: 'staying-relevant',
  },
  {
    title: 'pages.onboarding.careerPriority.meaningfulWork',
    subtitle: 'pages.onboarding.careerPriority.meaningfulWorkSub',
    value: 'meaningful-work',
  },
  {
    title: 'pages.onboarding.careerPriority.havingOptions',
    subtitle: 'pages.onboarding.careerPriority.havingOptionsSub',
    value: 'having-options',
  },
]

export default function CareerPriorityPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.careerPriority.title"
      subtitle="pages.onboarding.careerPriority.subtitle"
    />
  )
}
